import type { BlogPost } from "./blog";

export const BLOG_FAQ_PART2: BlogPost[] = [
  {
    "slug": "kak-zabronirovat-stol-restoran-peterburg",
    "title": "Как забронировать стол в ресторане в Петербурге",
    "metaTitle": "Как забронировать стол в ресторане Петербурга | Паруса на крыше",
    "metaDescription": "Как правильно забронировать стол в ресторане Санкт-Петербурга: способы, советы, что уточнить.",
    "keywords": "как забронировать стол ресторан петербург, бронирование стола ресторан спб, забронировать стол спб",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Бронирование стола в ресторане — простая процедура, которая экономит нервы и гарантирует место. Расскажем, как это сделать правильно.",
    "sections": [
      {
        "heading": "Способы забронировать стол",
        "body": "Телефон: классика, позволяет задать вопросы сразу. Сайт ресторана или форма на странице: быстро, в любое время. Агрегаторы (Яндекс, 2ГИС): удобно для сравнения. Для «Парусов на крыше» (ул. Марата, 5): +7 (812) 991-10-90 или форма на сайте.",
        "list": [
          "Телефон: можно задать вопросы о меню, виде, вместимости",
          "Онлайн-форма: удобно в любое время суток",
          "Агрегаторы: Яндекс и 2ГИС часто поддерживают онлайн-бронь",
          "Мессенджеры: некоторые рестораны принимают в WhatsApp"
        ]
      },
      {
        "heading": "Что уточнить при бронировании",
        "body": "Обязательно: количество гостей, дата и время. Желательно: особый повод (ДР, свидание), предпочтение по месту (у окна, в тихой зоне), аллергии или ограничения в питании. При бронировании «Парусов» попросите столик у окна с видом — это конкретный запрос, который выполнят при наличии мест.",
        "highlight": "Совет: всегда уточняйте, нужна ли предоплата или депозит. Некоторые рестораны требуют гарантию для больших групп или популярных дат."
      },
      {
        "heading": "Когда бронировать",
        "body": "Будни: обычно достаточно за 1–2 дня. Пятница/суббота: за 3–7 дней. Праздники (8 марта, 23 февраля, Новый год): за 1–2 месяца. Особые события (ДР, свадьба): чем раньше, тем лучше — за 2–4 недели. Читайте о <a href='/blog/nuzhno-li-bronirovat-stol-spb' class='underline text-accent'>том, нужно ли бронировать</a>."
      }
    ],
    "cta": { "text": "Забронировать стол в «Парусах»", "href": "/" }
  },
  {
    "slug": "nuzhno-li-bronirovat-stol-restoran-spb",
    "title": "Нужно ли бронировать стол в ресторане в СПб?",
    "metaTitle": "Нужно ли бронировать стол в ресторане СПб | Паруса на крыше",
    "metaDescription": "Когда в Петербурге обязательно бронировать стол в ресторане, а когда можно прийти без брони.",
    "keywords": "нужно ли бронировать стол ресторан спб, бронь стола ресторан нужна ли, без брони ресторан петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Зависит от дня, времени и ресторана. Расскажем, когда бронь обязательна, а когда можно прийти без неё.",
    "sections": [
      {
        "heading": "Когда бронировать обязательно",
        "body": "Пятница и суббота вечером: большинство популярных ресторанов центра заняты. Праздничные даты: 8 марта, 23 февраля, 14 февраля, Новый год — за 2–4 недели. Особые поводы: дни рождения, юбилеи — нужна конкретная дата и зал. Группы от 6+ человек: всегда нужна предварительная бронь.",
        "list": [
          "Пятница/суббота вечер: обязательно",
          "Праздники: за 2–4 недели",
          "Группы 6+ человек: всегда бронировать",
          "Особые поводы: как можно раньше"
        ]
      },
      {
        "heading": "Когда можно прийти без брони",
        "body": "Будни обед/ужин (понедельник–четверг): обычно есть места. Поздний ужин (после 21:30): рестораны частично освобождаются. Ранний ужин (17:00–18:30): не пиковое время. В «Парусах на крыше» (ул. Марата, 5) в популярные дни лучше забронировать заранее. Звонок за час до визита: +7 (812) 991-10-90.",
        "highlight": "Простое правило: если вам важен конкретный столик (у окна, в тихом месте) — всегда бронируйте. Без брони получите то, что останется."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kak-vybrat-restoran-dlya-banka-spb",
    "title": "Как выбрать ресторан для банкета в СПб: критерии",
    "metaTitle": "Как выбрать ресторан для банкета СПб | Паруса на крыше",
    "metaDescription": "Критерии выбора ресторана для банкета в Санкт-Петербурге: вместимость, меню, цена, сервис.",
    "keywords": "как выбрать ресторан банкет спб, выбор ресторана банкет петербург, критерии ресторан банкет",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Выбор ресторана для банкета — ответственное решение. Неправильный выбор испортит событие. Правильный — создаст воспоминание на годы. Разберём критерии.",
    "sections": [
      {
        "heading": "Ключевые критерии для банкета",
        "body": "Вместимость: зал должен вмещать ваших гостей комфортно. Идеально: 1 гость = 1,2–1,5 м² зала. Кухня: попробуйте заранее — закажите ужин и оцените уровень. Сервис: профессиональный ли персонал, есть ли менеджер мероприятий. Технический райдер: экран, проектор, микрофон, музыка. Цена и депозит: каков банкетный пакет, что входит, каковы условия отмены.",
        "list": [
          "Вместимость: 1 гость = 1,2–1,5 м² для комфорта",
          "Кухня: попробуйте до банкета",
          "Менеджер мероприятий: важно для организации",
          "Технический райдер: что есть, что нет"
        ]
      },
      {
        "heading": "Чеклист при выборе",
        "body": "Посетите ресторан лично — оцените зал, атмосферу, сервис. Уточните: есть ли выделенный менеджер для вашего мероприятия? Какой минимальный гарантированный чек? Условия при меньшем количестве гостей? «Паруса на крыше» (ул. Марата, 5): зал до 300 гостей, банкетное меню от 2 500 ₽/чел, менеджер мероприятий, живая музыка. Рейтинг 5,0.",
        "highlight": "Попросите дегустацию банкетного меню перед заказом. Хороший ресторан организует это без проблем — это часть продажи."
      },
      {
        "heading": "Читайте также",
        "body": "О банкетных пакетах подробнее: <a href='/blog/chto-vkhodit-banketnyy-paket-korporativ' class='underline text-accent'>что входит в банкетный пакет</a>. О выборе зала: <a href='/blog/gde-zakazat-zal-den-rozhdeniya-peterburg' class='underline text-accent'>где заказать зал на ДР</a>."
      }
    ],
    "cta": { "text": "Узнать о банкетах в «Парусах»", "href": "/banket" }
  },
  {
    "slug": "sredney-chek-restoran-peterburg",
    "title": "Средний чек в ресторанах Петербурга: сколько нужно",
    "metaTitle": "Средний чек в ресторанах Петербурга 2026 | Паруса на крыше",
    "metaDescription": "Сколько стоит ужин в ресторане Санкт-Петербурга: средний чек по категориям ресторанов.",
    "keywords": "средний чек ресторан петербург, сколько стоит ужин ресторан спб, ресторан цены петербург 2026",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Сколько стоит ужин в ресторане Петербурга? Зависит от категории. Разберём цены честно.",
    "sections": [
      {
        "heading": "Ценовые категории ресторанов",
        "body": "Бюджетный (столовые, бистро): 300–600 ₽/чел. Средний (кафе, рестораны среднего уровня): 700–1 500 ₽/чел. Выше среднего (авторские рестораны, панорамные): 1 200–2 500 ₽/чел. Премиум (топ рестораны, дегустационные меню): от 3 000 ₽/чел. Туристические ловушки у Невского: 1 500–2 500 ₽ при среднем качестве.",
        "list": [
          "Бюджет: 300–600 ₽ (столовые, бистро)",
          "Средний: 700–1 500 ₽ (большинство ресторанов)",
          "Выше среднего: 1 200–2 500 ₽ (авторская кухня)",
          "Премиум: от 3 000 ₽ (топ-рестораны)"
        ]
      },
      {
        "heading": "«Паруса» в ценовой структуре",
        "body": "«Паруса на крыше» (ул. Марата, 5): средний чек около 1 300 ₽/человек. Бизнес-ланч от 590 ₽, банкетное меню от 2 500 ₽/чел. Это категория «выше среднего», но с исключительным видом и репутацией (рейтинг 5,0, 2 606 отзывов). Соотношение цена/впечатление — одно из лучших в Петербурге."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "chto-takoe-depozit-restoran",
    "title": "Что такое депозит в ресторане и как он работает",
    "metaTitle": "Что такое депозит в ресторане — объяснение | Паруса на крыше",
    "metaDescription": "Что такое депозит при бронировании ресторана: как работает, можно ли вернуть, что происходит при отмене.",
    "keywords": "депозит ресторан что это, депозит при бронировании ресторана, как работает депозит ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Депозит при бронировании ресторана — распространённая практика. Многие гости не понимают, как это работает. Объясняем.",
    "sections": [
      {
        "heading": "Как работает депозит",
        "body": "Депозит — авансовый платёж, который подтверждает серьёзность намерений. Он входит в счёт в день визита: если вы пришли и потратили больше депозита — доплачиваете. Если отменили — условия возврата зависят от политики ресторана (обычно: за 24–48 часов до — возврат, позже — не возвращается). Для банкетов и мероприятий депозит обязателен.",
        "list": [
          "Депозит = аванс, входит в счёт в день визита",
          "Отмена заблаговременно: обычно возврат",
          "Отмена поздно или неявка: как правило, не возвращается",
          "Для банкетов: обычно 20–50% от стоимости"
        ]
      },
      {
        "heading": "Депозит в «Парусах»",
        "body": "Условия депозита в «Парусах» (ул. Марата, 5) уточняйте при бронировании: +7 (812) 991-10-90. Для обычных столиков депозит обычно не требуется. Для банкетных мероприятий — уточняйте условия заранее. Всегда фиксируйте договорённость: что входит в депозит, каковы условия отмены."
      }
    ],
    "cta": { "text": "Уточнить условия бронирования", "href": "/" }
  },
  {
    "slug": "kak-vesti-sebya-v-restorane-etiket",
    "title": "Как вести себя в ресторане: этикет для гостя",
    "metaTitle": "Этикет в ресторане — как правильно вести себя | Паруса",
    "metaDescription": "Основы ресторанного этикета: как заказывать, как вести себя за столом, чаевые и другие правила.",
    "keywords": "как вести себя в ресторане этикет, ресторанный этикет правила, этикет ресторан россия",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Ресторанный этикет — не свод жёстких правил, а набор простых вежливых практик. Большинство из них — просто здравый смысл.",
    "sections": [
      {
        "heading": "Основные правила поведения в ресторане",
        "body": "Приходите в оговорённое время или предупредите об опоздании. Не садитесь за столик до того, как вас проводят. Меню изучают молча, не щёлкая пальцами для привлечения официанта (поднятая рука или зрительный контакт — вежливо). Сотовый телефон: не ставьте на стол лицом вверх, разговоры по громкой связи — недопустимы. Верхнюю одежду сдайте в гардероб.",
        "list": [
          "Опоздание: предупредите ресторан",
          "Привлечение официанта: зрительный контакт или поднятая рука",
          "Телефон: со стола убрать или перевернуть",
          "Разговор по телефону: выйдите из зала"
        ]
      },
      {
        "heading": "Особенности российского этикета",
        "body": "В России нет строгого дресс-кода в большинстве ресторанов (если не указано иное). Чаевые: 10–15% — стандарт, если обслуживание понравилось. Алкоголь: нормально попросить карту вин отдельно. Остатки еды: нормально попросить завернуть с собой (doggy bag). Официант не будет торопить вас уходить после оплаты.",
        "highlight": "Если блюдо не понравилось — скажите официанту сразу, а не молчите до оплаты. Хороший ресторан всегда решит проблему."
      }
    ],
    "cta": { "text": "Забронировать стол в «Парусах»", "href": "/" }
  },
  {
    "slug": "chaevye-restoran-skolko-ostavlyat",
    "title": "Чаевые в ресторане: сколько оставлять в России",
    "metaTitle": "Чаевые в ресторане — сколько оставлять в России | Паруса",
    "metaDescription": "Сколько чаевых оставлять в ресторане в России: нормы, стандарты, когда можно не оставлять.",
    "keywords": "чаевые ресторан россия сколько, чаевые ресторан петербург, сколько давать чаевых в ресторане",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Чаевые в России — добровольная практика, но важная часть дохода персонала. Расскажем, какие нормы приняты и как их оставить.",
    "sections": [
      {
        "heading": "Стандарты чаевых в России",
        "body": "Нормальные чаевые: 10–15% от суммы счёта. Хорошее обслуживание: 15–20%. Удовлетворительное: 5–10%. Плохое: можно не оставлять, но стоит поговорить с менеджером. Если в счёт уже включён сервисный сбор (обычно 10–15%) — чаевые необязательны, но можно добавить дополнительно за отличный сервис.",
        "list": [
          "Стандарт: 10–15% от счёта",
          "Хорошее обслуживание: 15–20%",
          "Включённый сервисный сбор: чаевые не обязательны",
          "Наличные чаевые официанту: прямые, сразу"
        ]
      },
      {
        "heading": "Как оставить чаевые",
        "body": "Наличными: положить на блюдце для чека или передать официанту с фразой «и вам». Картой: некоторые рестораны позволяют добавить чаевые при оплате картой. В «Парусах» (ул. Марата, 5) чаевые принимаются в обоих форматах. Помните: официанты часть делятся чаевыми с командой (повара, бармены, хостес)."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "chto-takoe-set-menyu-restoran",
    "title": "Что такое сет-меню в ресторане: объяснение",
    "metaTitle": "Что такое сет-меню в ресторане | Паруса на крыше СПб",
    "metaDescription": "Что такое сет-меню в ресторане: как устроено, сколько перемен, чем отличается от обычного меню.",
    "keywords": "сет меню ресторан что это, что такое сет в ресторане, сет меню объяснение",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Сет-меню (от английского set menu) — фиксированный набор блюд за фиксированную цену. Это альтернатива выбору à la carte, когда вы заказываете каждое блюдо отдельно.",
    "sections": [
      {
        "heading": "Виды сет-меню",
        "body": "Бизнес-ланч: самый распространённый сет — фиксированный обед в будни (суп + горячее + напиток). Банкетное меню: для мероприятий — несколько перемен для всего стола. Дегустационный сет (tasting menu): 5–10 маленьких перемен от шефа, авторский опыт. Сезонный сет: ограниченное меню с сезонными продуктами.",
        "list": [
          "Бизнес-ланч: самый распространённый формат сета",
          "Банкетное меню: для мероприятий",
          "Дегустационный: 5–10 перемен, авторский опыт",
          "Сезонный: с акцентом на сезонные продукты"
        ]
      },
      {
        "heading": "Зачем ресторан предлагает сет-меню",
        "body": "Для ресторана: предсказуемость в производстве, снижение потерь, более быстрое обслуживание. Для гостя: меньше нужно думать, фиксированная цена, часто выгоднее à la carte. В «Парусах» (ул. Марата, 5) бизнес-ланч от 590 ₽ — пример сет-меню. Банкетное меню от 2 500 ₽/чел. Читайте о <a href='/blog/degustatsionnyy-set-restoran-peterburg' class='underline text-accent'>дегустационном сете</a>."
      }
    ],
    "cta": { "text": "Посмотреть меню ресторана", "href": "/menu" }
  },
  {
    "slug": "est-li-parkovka-ryadom-olympic-plaza",
    "title": "Есть ли парковка у ресторана «Паруса» на Марата",
    "metaTitle": "Парковка у ресторана Паруса на Марата СПб | Паруса на крыше",
    "metaDescription": "Есть ли парковка у ресторана «Паруса на крыше» на улице Марата 5 в Петербурге: варианты и советы.",
    "keywords": "парковка паруса на крыше, парковка рестораны центр спб, парковка улица марата петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/view_day.webp",
    "lead": "Центр Петербурга — зона с платной парковкой. Расскажем, как добраться до «Парусов на крыше» с автомобилем.",
    "sections": [
      {
        "heading": "Парковка у Olympic Plaza",
        "body": "В Olympic Plaza (ул. Марата, 5) есть внутренняя парковка. Также рядом работает платная городская парковка на улице Марата и прилегающих улицах. Стоимость: в соответствии с тарифами城市платных парковок центра. Вечером (после 20:00) и в выходные стоимость ниже или бесплатно в зависимости от зоны.",
        "list": [
          "Olympic Plaza: внутренняя парковка",
          "Улица Марата: платная городская парковка",
          "Вечером и выходные: дешевле или бесплатно",
          "Альтернатива: метро Владимирская — 5 минут пешком"
        ]
      },
      {
        "heading": "Альтернативы парковке",
        "body": "Метро Владимирская: 5 минут пешком — самый удобный вариант для гостей из других районов. Такси или каршеринг: не нужно думать о парковке. Автобусы и трамвай: остановки рядом с Olympic Plaza. Для особых мероприятий — уточните у ресторана возможность договориться о парковке заблаговременно: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kak-doekhat-do-parusov-na-kryishe",
    "title": "Как добраться до ресторана «Паруса на крыше»",
    "metaTitle": "Как добраться до Парусов на крыше — маршрут | Паруса СПб",
    "metaDescription": "Как добраться до ресторана «Паруса на крыше» на улице Марата 5 в Петербурге: метро, транспорт, парковка.",
    "keywords": "как добраться до парусов на крыше, паруса на крыше как доехать, олимпик плаза метро",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/view_day.webp",
    "lead": "Ресторан «Паруса на крыше» находится в Olympic Plaza, ул. Марата, 5, 6-й этаж, Центральный район Петербурга. Добраться несложно.",
    "sections": [
      {
        "heading": "Как добраться на метро",
        "body": "Ближайшие станции метро: Владимирская (5 минут пешком — самый удобный вариант), Маяковская (10 минут пешком), Достоевская (7 минут пешком). Путь от метро Владимирская: выход на Загородный проспект, повернуть на улицу Марата, идти 3 минуты. Здание Olympic Plaza хорошо видно — современный бизнес-центр.",
        "list": [
          "Владимирская: 5 минут пешком",
          "Достоевская: 7 минут пешком",
          "Маяковская: 10 минут пешком",
          "Невский: 10–15 минут пешком"
        ]
      },
      {
        "heading": "На такси и общественном транспорте",
        "body": "Такси: «Марата 5, Olympic Plaza» — любой адрес навигатора. Автобусы: несколько маршрутов останавливаются на Загородном проспекте. Трамвай: маршруты через Загородный проспект. От Московского вокзала: 15 минут пешком или 5 минут на такси. Телефон для вопросов: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kak-otmenit-bronirovanie-restoran",
    "title": "Как отменить бронирование в ресторане: правила",
    "metaTitle": "Как отменить бронирование в ресторане | Паруса на крыше СПб",
    "metaDescription": "Как правильно отменить бронирование в ресторане в Петербурге: сроки, условия, возврат депозита.",
    "keywords": "отменить бронирование ресторан, отмена брони ресторан петербург, как отменить столик ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Планы меняются. Если вам нужно отменить бронирование в ресторане — сделайте это правильно, чтобы сохранить хорошие отношения и, возможно, вернуть депозит.",
    "sections": [
      {
        "heading": "Как правильно отменить бронь",
        "body": "Позвоните или напишите ресторану как можно раньше — это ключевое. Стандартные условия отмены: за 24–48 часов до визита — обычно без штрафа. Менее 24 часов — возможна потеря депозита. В день визита или неявка — как правило, депозит не возвращается. Для банкетов и мероприятий — условия отмены прописываются в договоре отдельно.",
        "list": [
          "За 48+ часов: обычно без штрафа",
          "За 24 часа: зависит от условий",
          "В день визита: часто потеря депозита",
          "Банкеты: условия в договоре"
        ]
      },
      {
        "heading": "Отмена брони в «Парусах»",
        "body": "Для отмены бронирования в «Парусах» (ул. Марата, 5) позвоните: +7 (812) 991-10-90. Если возникла форс-мажорная ситуация — объясните, хороший ресторан идёт навстречу. Уважайте чужое время: неявка без предупреждения — это занятый стол, который мог достаться другому гостю."
      }
    ],
    "cta": { "text": "Уточнить условия бронирования", "href": "/" }
  },
  {
    "slug": "chto-delat-esli-blyudo-ne-ponravilos",
    "title": "Что делать, если блюдо не понравилось в ресторане",
    "metaTitle": "Что делать если блюдо не понравилось в ресторане | Паруса",
    "metaDescription": "Как поступить, если блюдо в ресторане не понравилось: правила, этикет, как сказать официанту.",
    "keywords": "блюдо не понравилось в ресторане что делать, претензия ресторан блюдо, недовольны блюдом ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/food.webp",
    "lead": "Блюдо не оправдало ожиданий. Это неприятно, но это не катастрофа. Расскажем, как поступить правильно — без скандала и с результатом.",
    "sections": [
      {
        "heading": "Алгоритм действий",
        "body": "Не ешьте молча. Скажите официанту сразу (не через час, не в конце трапезы). Объясните конкретно: пересолено, холодное, не то что заказывали, испорченный продукт. Хороший официант предложит решение: заменить блюдо, убрать из счёта, позвать менеджера. Вы имеете право на правильно приготовленное блюдо, которое соответствует описанию в меню.",
        "list": [
          "Скажите сразу, не молчите",
          "Конкретно: что именно не так",
          "Решение: замена или скидка",
          "Не скандальте: спокойный разговор эффективнее"
        ]
      },
      {
        "heading": "Разница между «не понравилось» и «неправильно приготовлено»",
        "body": "«Не мой вкус» — это не основание для бесплатной замены. «Сырое мясо при заказе well-done», «холодное блюдо», «не то блюдо» — это основание. В «Парусах» (ул. Марата, 5) с рейтингом 5,0 такие ситуации редки, но если возникнут — персонал готов решить. Рейтинг 5,0 при 2 606 отзывах говорит сам за себя."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kak-vybrat-restoran-po-yandeks-kartam",
    "title": "Как выбрать ресторан по Яндекс Картам в СПб",
    "metaTitle": "Как выбрать ресторан по Яндекс Картам СПб | Паруса на крыше",
    "metaDescription": "Как правильно читать Яндекс Карты при выборе ресторана в Петербурге: рейтинг, отзывы, фото.",
    "keywords": "как выбрать ресторан яндекс карты, яндекс карты ресторан выбор, рейтинг ресторан яндекс спб",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Яндекс Карты — главный инструмент выбора ресторанов в России. Но не все умеют их читать правильно. Поделимся советами.",
    "sections": [
      {
        "heading": "Как читать рейтинг на Яндекс Картах",
        "body": "Рейтинг важен в контексте количества отзывов. 5,0 при 20 отзывах — не показатель. 5,0 при 2 000+ отзывах — реальная репутация. Фильтр «Хорошее место» от Яндекса: автоматически присваивается заведениям со стабильно высокой оценкой. Читайте фото: реальные фото от гостей честнее официальных съёмок.",
        "list": [
          "Рейтинг + количество отзывов: важна пара",
          "«Хорошее место»: автоматический знак качества Яндекса",
          "Фото от гостей: реальнее официальных",
          "Последние отзывы: отражают актуальное состояние"
        ]
      },
      {
        "heading": "«Паруса» на Яндекс Картах",
        "body": "«Паруса на крыше» (ул. Марата, 5): рейтинг 5,0 при 2 606 отзывах — один из лучших показателей в Петербурге. Знак «Хорошее место 2026». Отзывы содержат реальные фото вида, блюд, атмосферы. По этим критериям — один из лидеров панорамных ресторанов центра. Читайте о <a href='/blog/restorany-s-reitingom-50-yandex-spb' class='underline text-accent'>ресторанах с рейтингом 5,0</a>."
      }
    ],
    "cta": { "text": "Открыть нас на Яндекс Картах", "href": "/" }
  },
  {
    "slug": "kak-organizovat-syurpriz-dr-restoran",
    "title": "Как организовать сюрприз на день рождения в ресторане",
    "metaTitle": "Как организовать сюрприз на ДР в ресторане | Паруса на крыше",
    "metaDescription": "Пошаговая инструкция по организации сюрприза на день рождения в ресторане Петербурга.",
    "keywords": "сюрприз день рождения ресторан организовать, как сделать сюрприз в ресторане спб, организация сюрприза ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Сюрприз-ДР в ресторане — один из самых трогательных форматов. Но требует планирования. Вот пошаговая инструкция.",
    "sections": [
      {
        "heading": "Пошаговый план",
        "body": "Шаг 1: выберите ресторан и забронируйте (предупредите, что это сюрприз). Шаг 2: пригласите гостей, объясните план и время прихода (на 20 минут раньше именинника). Шаг 3: придумайте легенду — почему именинник идёт в ресторан (например: «я хочу просто поужинать вдвоём»). Шаг 4: договоритесь о сигнале, когда именинник подходит. Шаг 5: все ждут в зале, когда открывается дверь — звучат аплодисменты.",
        "list": [
          "Шаг 1: ресторан + предупреждение о сюрпризе",
          "Шаг 2: гости приходят на 20 минут раньше",
          "Шаг 3: легенда для именинника",
          "Шаг 4: сигнал по SMS или звонку"
        ]
      },
      {
        "heading": "Что подготовить заранее",
        "body": "Торт со свечами (уточните у ресторана — можно ли принести). Фото-зону или баннер. Любимые цветы. Шампанское для тоста. В «Парусах» (ул. Марата, 5) организация сюрпризов — обычная практика. Скидка 20% для именинника. Читайте о <a href='/blog/syurpriz-restoran-den-rozhdeniya-spb' class='underline text-accent'>сюрпризе в ресторане</a>."
      }
    ],
    "cta": { "text": "Организовать сюрприз", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "detskoe-menyu-restoran-chto-dolzhno-byt",
    "title": "Детское меню в ресторане: что должно быть",
    "metaTitle": "Детское меню в ресторане — что включать | Паруса на крыше",
    "metaDescription": "Что должно быть в детском меню ресторана: блюда, порции, напитки. Как выбрать ресторан для семьи.",
    "keywords": "детское меню ресторан что должно быть, детское меню состав ресторан, ресторан с детским меню спб",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Детское меню в ресторане — не просто «маленькие порции взрослых блюд». Хорошее детское меню думает о ребёнке: понятные вкусы, правильные порции, натуральные ингредиенты.",
    "sections": [
      {
        "heading": "Что должно быть в хорошем детском меню",
        "body": "Обязательный состав: паста (макароны с соусом), блины или оладьи, куриное блюдо (котлета, наггетсы), суп (не острый). Желательно: безмолочные варианты, блюда без глютена по запросу, натуральные напитки (компот, свежий сок). Важно: меньшие порции при меньшей цене, а не полные взрослые порции «на детскую цену».",
        "list": [
          "Паста: любимое детское блюдо, вариации всегда популярны",
          "Куриное: нейтральный вкус, знакомо",
          "Блины/оладьи: традиционно нравятся детям",
          "Компот или натуральный сок: без газа и краситей"
        ]
      },
      {
        "heading": "Детское меню в «Парусах»",
        "body": "В «Парусах» (ул. Марата, 5) детское меню включает блюда для детей разных возрастов. Для мероприятий с детьми — уточните состав при бронировании: +7 (812) 991-10-90. Вид с 6-го этажа производит впечатление на детей не меньше, чем на взрослых. Рейтинг 5,0, «Хорошее место 2026»."
      }
    ],
    "cta": { "text": "Забронировать семейный ужин", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "allergiya-dieta-restoran-kak-skazat",
    "title": "Аллергия и диета в ресторане: как сообщить",
    "metaTitle": "Аллергия в ресторане — как сообщить о диете | Паруса",
    "metaDescription": "Как сообщить об аллергии или диетических ограничениях в ресторане: когда говорить, как формулировать.",
    "keywords": "аллергия ресторан как сказать, диетические ограничения ресторан, аллергия ресторан петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/food.webp",
    "lead": "Аллергия на продукты или диетические ограничения — серьёзная медицинская потребность. Хороший ресторан отнесётся к этому с уважением. Расскажем, как правильно сообщить.",
    "sections": [
      {
        "heading": "Когда и как сообщить",
        "body": "При бронировании: идеально — сообщите заранее по телефону или в комментарии к брони. При посадке: напомните официанту до заказа. При заказе: уточните состав блюда, попросите убрать аллерген или заменить. Серьёзные аллергии (анафилаксия на орехи, глютен при целиакии): сообщайте максимально чётко — это вопрос здоровья.",
        "list": [
          "При бронировании: лучший момент для предупреждения",
          "При посадке: напомните официанту",
          "При заказе: уточните состав конкретных блюд",
          "Серьёзные аллергии: будьте чёткими, не стесняйтесь"
        ]
      },
      {
        "heading": "В «Парусах»",
        "body": "«Паруса» (ул. Марата, 5) принимают информацию об аллергиях при бронировании: +7 (812) 991-10-90. Шеф-повар может адаптировать ряд блюд под ограничения. Не стесняйтесь спрашивать — это профессиональная обязанность ресторана. Рейтинг 5,0 предполагает высокий уровень внимания к гостям."
      }
    ],
    "cta": { "text": "Сообщить об аллергии при бронировании", "href": "/" }
  },
  {
    "slug": "gde-poest-pozdno-noch-peterburg",
    "title": "Где поесть поздно ночью в Петербурге",
    "metaTitle": "Где поесть поздно ночью в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Рестораны Санкт-Петербурга, работающие поздно ночью: где поесть после полуночи.",
    "keywords": "где поесть ночью петербург, ночной ресторан спб, рестораны работающие поздно петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "После разводных мостов или позднего вечера в городе хочется поесть. В Петербурге есть несколько форматов для позднего питания.",
    "sections": [
      {
        "heading": "Варианты позднего питания в Петербурге",
        "body": "Круглосуточные заведения: «Камчатка», несколько сетевых кафе и пиццерий. Бары с едой: работают до 2–5 ночи, ограниченное меню. Доставка: большинство сервисов работает до 2–3 ночи. Рестораны с поздним закрытием: некоторые заведения центра работают до 23:00–00:00.",
        "list": [
          "Круглосуточные: сетевые кафе, «Макдоналдс»-формат",
          "Бары с едой: до 2–5 утра",
          "Доставка: большинство до 2–3 ночи",
          "Рестораны с поздним закрытием: до 23:00–00:00"
        ]
      },
      {
        "heading": "«Паруса» и время работы",
        "body": "Уточняйте время работы «Парусов» при бронировании: +7 (812) 991-10-90. В праздники и особые события ресторан может работать позже обычного. Для ужина после разводных мостов — лучше спланировать ужин до 22:00–23:00, а затем пойти к мостам."
      }
    ],
    "cta": { "text": "Уточнить время работы", "href": "/" }
  },
  {
    "slug": "chto-takoe-khoroshee-mesto-yandeks",
    "title": "Что такое «Хорошее место» на Яндекс Картах",
    "metaTitle": "Хорошее место Яндекс Карты — что это | Паруса на крыше СПб",
    "metaDescription": "Что значит знак «Хорошее место» на Яндекс Картах: как присваивается, что означает для ресторана.",
    "keywords": "хорошее место яндекс карты что это, хорошее место 2026 яндекс, значок хорошее место ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "«Хорошее место» — значок на Яндекс Картах, который автоматически присваивается заведениям с высокой и стабильной репутацией. Разберём, что это означает.",
    "sections": [
      {
        "heading": "Как работает «Хорошее место»",
        "body": "Яндекс присваивает значок «Хорошее место» автоматически на основе: высокого рейтинга (обычно 4,5+), большого количества отзывов, стабильности оценок во времени, отсутствия жалоб на качество. Это не платная опция — купить нельзя. Ежегодно обновляется (поэтому «2026» в названии — актуальный знак).",
        "list": [
          "Автоматически: нельзя купить или заказать",
          "Критерии: высокий рейтинг + много отзывов + стабильность",
          "Ежегодно обновляется: «2025», «2026» и т.д.",
          "Достоверность: основана на реальных отзывах"
        ]
      },
      {
        "heading": "«Паруса» — «Хорошее место 2026»",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5) удерживает звание «Хорошее место» несколько лет подряд. Рейтинг 5,0 при 2 606 отзывах — один из лучших показателей в Петербурге. Это означает: большинство гостей уходят довольными и оставляют позитивные отзывы. Читайте о <a href='/blog/khoroshee-mesto-2026-restoran-spb' class='underline text-accent'>знаке «Хорошее место»</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restoran-na-kryishe-zachem-idti",
    "title": "Ресторан на крыше: что нужно знать перед визитом",
    "metaTitle": "Ресторан на крыше — что нужно знать | Паруса на крыше СПб",
    "metaDescription": "Что нужно знать перед посещением ресторана на крыше в Петербурге: сезонность, одежда, бронирование.",
    "keywords": "ресторан на крыше что нужно знать, паруса на крыше посещение, ресторан крыша петербург советы",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/terrace.webp",
    "lead": "Ресторан «на крыше» — особый формат. Несколько вещей стоит знать перед первым визитом.",
    "sections": [
      {
        "heading": "Что нужно знать о «Парусах»",
        "body": "Формат: «Паруса на крыше» — это ресторан на 6-м этаже Olympic Plaza с панорамными окнами и открытой террасой в тёплое время. Это не экскурсия на крышу — это полноценный ресторан с кухней, сервисом и банкетным залом. Работает круглый год (терраса — летом). Вид: 300° панорама исторического центра.",
        "list": [
          "Работает круглый год: не сезонный",
          "Терраса: открытая площадка летом (май–сентябрь)",
          "Вид: 300° панорама, Казанский собор в кадре",
          "Полноценный ресторан: меню, сервис, банкет"
        ]
      },
      {
        "heading": "Практические советы",
        "body": "Бронируйте заранее (особенно пятница/суббота). Попросите столик у окна с видом при бронировании. Летом: одевайтесь по погоде — на террасе может быть ветер даже в тёплый день. Зимой: внутри тепло и уютно. Телефон: +7 (812) 991-10-90. Адрес: ул. Марата, 5, 6-й этаж."
      }
    ],
    "cta": { "text": "Забронировать стол в «Парусах»", "href": "/" }
  },
  {
    "slug": "terrasa-restoran-zimoy-rabotaet-spb",
    "title": "Открытая терраса ресторана зимой: работает ли в СПб",
    "metaTitle": "Терраса ресторана зимой в СПб — работает ли | Паруса",
    "metaDescription": "Работают ли открытые террасы ресторанов в Петербурге зимой: ответ про «Паруса на крыше».",
    "keywords": "терраса ресторан зимой спб, работает ли терраса зима петербург, открытая терраса зимой ресторан",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/view_day.webp",
    "lead": "Открытые террасы ресторанов в Петербурге — сезонный формат. Расскажем, как это работает в «Парусах».",
    "sections": [
      {
        "heading": "Открытая терраса «Парусов»",
        "body": "Открытая терраса «Парусов» (ул. Марата, 5, 6 этаж) работает в тёплое время года — примерно с мая по сентябрь. Точное открытие зависит от погоды. Зимой — терраса закрыта, но ресторан работает полностью в закрытом помещении с панорамными окнами. Зимний вид на Петербург — отдельная эстетика: снег на крышах, подсветка куполов.",
        "list": [
          "Терраса: май–сентябрь (зависит от погоды)",
          "Зимой: ресторан работает, только внутри",
          "Панорамные окна зимой: не хуже, чем открытая терраса",
          "Снежный Петербург с 6-го этажа — особое зрелище"
        ]
      },
      {
        "heading": "Зимний ресторан vs летняя терраса",
        "body": "Летом: открытая терраса, свежий воздух, белые ночи — особая магия. Зимой: тёплый уютный зал, горящие свечи (или огни города за окном), закат в 15:30 — другая, не менее красивая атмосфера. Оба варианта стоят визита. Уточняйте актуальное состояние террасы: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать зимний ужин", "href": "/" }
  },
  {
    "slug": "stoit-li-idti-v-restoran-v-budni",
    "title": "Стоит ли идти в ресторан в будний день",
    "metaTitle": "Стоит ли идти в ресторан в будний день | Паруса на крыше",
    "metaDescription": "Плюсы и минусы похода в ресторан в будние дни: доступность, цены, атмосфера. Когда стоит выбрать будни.",
    "keywords": "ресторан в будни плюсы, идти в ресторан в будни, ресторан в будний день vs выходные",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Будни в ресторане — недооценённый формат. Расскажем, когда будни лучше выходных.",
    "sections": [
      {
        "heading": "Преимущества будней",
        "body": "Доступность: столики есть без брони за несколько дней. Цены: бизнес-ланч — дешевле, чем вечерний à la carte. Атмосфера: тише, меньше людей, более спокойный сервис. Внимание официанта: в загруженную пятницу у него 8 столиков, в среду — 3. Разница заметна. Для деловой встречи: тишина важна — будни подходят лучше.",
        "list": [
          "Нет переполненности: лучший сервис",
          "Бизнес-ланч: дешевле и быстрее",
          "Деловые встречи: тихая атмосфера в будни",
          "Бронь: за день, не за неделю"
        ]
      },
      {
        "heading": "Когда выбирать будни в «Парусах»",
        "body": "Бизнес-ланч (590 ₽) — только будни. Деловой ужин с клиентом — среда/четверг, когда тише. Романтический ужин вдвоём — будний вечер, если хотите тишины. В пятницу и субботу — живая музыка, больше атмосферы, но и больше людей. Телефон: +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать будний ужин", "href": "/" }
  },
  {
    "slug": "mozhno-li-priyti-s-zhivotnym-spb",
    "title": "Можно ли прийти в ресторан с животными в СПб",
    "metaTitle": "Можно ли прийти с животными в ресторан СПб | Паруса",
    "metaDescription": "Правила посещения ресторанов в Петербурге с домашними животными: где принимают, а где нет.",
    "keywords": "ресторан с животными спб, можно ли с собакой в ресторан петербург, рестораны петфрендли спб",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Домашние животные — часть жизни многих петербуржцев. Рассказываем, что нужно знать о посещении ресторанов с питомцами.",
    "sections": [
      {
        "heading": "Правила в России",
        "body": "По российскому законодательству: продукты питания и животные не могут находиться в одном помещении. Это значит, что в закрытый зал ресторана с животными нельзя по санитарным нормам. Исключение: летние террасы и веранды под открытым небом — там домашних животных нередко принимают.",
        "list": [
          "Закрытый зал: запрещено по санитарным нормам",
          "Летняя терраса: часто разрешено",
          "Маленькая собака в сумке-переноске: зависит от ресторана",
          "Уточняйте заранее при бронировании"
        ]
      },
      {
        "heading": "В «Парусах» с животными",
        "body": "Уточните правила посещения с животными при бронировании: +7 (812) 991-10-90. Летняя терраса может быть более лояльной. Закрытый зал — следует санитарным нормам. Для прогулки с питомцем вдоль улицы Марата или набережной Фонтанки — отличная альтернатива: прогуляйтесь, затем оставьте питомца у друга и поднимитесь на ужин."
      }
    ],
    "cta": { "text": "Уточнить правила посещения", "href": "/" }
  },
  {
    "slug": "restoran-wifi-peterburg-list",
    "title": "Ресторан с Wi-Fi в Петербурге: где поработать",
    "metaTitle": "Ресторан с Wi-Fi в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Рестораны с хорошим Wi-Fi в Санкт-Петербурге: где можно поработать за едой.",
    "keywords": "ресторан с wifi петербург, ресторан работать спб, кафе wifi центр петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/interior.webp",
    "lead": "Работа за ноутбуком в ресторане — петербургская традиция. Где найти Wi-Fi и комфортное место для этого.",
    "sections": [
      {
        "heading": "Что нужно для комфортной работы в ресторане",
        "body": "Надёжный Wi-Fi. Розетка рядом с местом. Не слишком громкая атмосфера. Лояльное отношение к «работающим» гостям (не торопят). Кофе по адекватной цене. В рабочие часы (10:00–17:00) большинство ресторанов более лояльны к людям с ноутбуками.",
        "list": [
          "Wi-Fi: уточните скорость при бронировании",
          "Розетка: спросите официанта",
          "Шум: тихий зал важен для концентрации",
          "Минимальный заказ: уточните политику"
        ]
      },
      {
        "heading": "«Паруса» для работы",
        "body": "«Паруса» (ул. Марата, 5) — ресторан, а не коворкинг. Но в обеденные часы будних дней здесь реально поработать за хорошим бизнес-ланчем (от 590 ₽). Wi-Fi в здании Olympic Plaza есть. Для длительной работы — лучше специализированные кафе или коворкинги. Для рабочей встречи с клиентом — «Паруса» оптимальны. Рейтинг 5,0."
      }
    ],
    "cta": { "text": "Забронировать обед", "href": "/" }
  },
  {
    "slug": "restoran-na-ulitsa-marata-5-kak-nayti",
    "title": "Ресторан на улице Марата 5 в СПб: как найти",
    "metaTitle": "Ресторан на Марата 5 — как найти Паруса на крыше | СПб",
    "metaDescription": "Как найти ресторан «Паруса на крыше» на улице Марата 5 в Петербурге: вход, лифт, ориентиры.",
    "keywords": "ресторан марата 5 спб как найти, паруса на крыше вход, олимпик плаза ресторан вход",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/view_day.webp",
    "lead": "Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж. Вот как найти вход и добраться до ресторана.",
    "sections": [
      {
        "heading": "Как найти «Паруса на крыше»",
        "body": "Адрес: улица Марата, 5. Здание: Olympic Plaza — современный бизнес-центр, хорошо видно на фоне исторической застройки. Вход: с улицы Марата в Olympic Plaza. Лифт: на 6-й этаж. Вывеска «Паруса на крыше» видна при выходе из лифта. Метро: Владимирская (5 минут пешком). Ориентиры: рядом — кинотеатр «Аврора», Загородный проспект, улица Достоевского.",
        "list": [
          "Адрес: ул. Марата 5, Olympic Plaza",
          "Вход: с улицы Марата в бизнес-центр",
          "Лифт: 6-й этаж",
          "Метро Владимирская: 5 минут пешком"
        ]
      },
      {
        "heading": "Если потерялись",
        "body": "Звоните: +7 (812) 991-10-90 — администратор объяснит. Навигатор: «Паруса на крыше, ул. Марата 5» — находит точно. Яндекс Карты: «Паруса на крыше СПб» — отзывы с фото входа есть. Читайте о <a href='/blog/kak-doekhat-do-parusov-na-kryishe' class='underline text-accent'>маршруте до ресторана</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "parusа-na-kryishe-istoriya-2009",
    "title": "«Паруса на крыше»: история ресторана с 2009 года",
    "metaTitle": "Паруса на крыше — история ресторана с 2009 | Паруса СПб",
    "metaDescription": "История ресторана «Паруса на крыше» в Петербурге: открытие в 2009, развитие, достижения.",
    "keywords": "паруса на крыше история ресторана, паруса на крыше с 2009, история ресторана паруса петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "«Паруса на крыше» работают с 2009 года. За 15+ лет ресторан стал одним из самых узнаваемых заведений Петербурга. Расскажем об истории.",
    "sections": [
      {
        "heading": "Открытие и первые годы",
        "body": "Ресторан открылся в 2009 году в Olympic Plaza (ул. Марата, 5) — одном из первых торгово-офисных центров Центрального района с коммерческими площадями на 6-м этаже. Концепция сразу была панорамной: использовать уникальное расположение для создания ресторана «над городом». Название «Паруса» — метафора высоты, свободы, движения.",
        "list": [
          "2009: открытие в Olympic Plaza",
          "Концепция с первого дня: панорама как главная ценность",
          "Название: паруса — метафора высоты и свободы",
          "Расположение: 6-й этаж, 300° обзор центра"
        ]
      },
      {
        "heading": "15 лет успеха",
        "body": "За 15+ лет работы «Паруса» собрали 2 606 отзывов с рейтингом 5,0 на Яндекс Картах. В 2026 году получили звание «Хорошее место». За эти годы здесь прошли тысячи дней рождения, свадеб, корпоративов. Ресторан пережил несколько кризисных лет в экономике — и остался открытым. Это показатель качества и устойчивости.",
        "highlight": "Ресторан, которому 15 лет — это не удача. Это системная работа команды, которая заботится о качестве каждого ужина."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "restan-na-6-etazhe-olimpik-plaza",
    "title": "Ресторан на 6-м этаже Olympic Plaza: что это такое",
    "metaTitle": "Ресторан на 6-м этаже Olympic Plaza Петербург | Паруса на крыше",
    "metaDescription": "Ресторан «Паруса на крыше» на 6-м этаже Olympic Plaza в Санкт-Петербурге: что это, где находится, как добраться.",
    "keywords": "ресторан 6 этаж олимпик плаза, паруса на крыше олимпик плаза, ресторан олимпик плаза петербург",
    "date": "2026-06-07",
    "category": "FAQ",
    "readTime": 4,
    "image": "/photos/view_day.webp",
    "lead": "Olympic Plaza — бизнес-центр на улице Марата, 5. На 6-м этаже — «Паруса на крыше». Отвечаем на самые частые вопросы.",
    "sections": [
      {
        "heading": "Основные факты",
        "body": "«Паруса на крыше» — ресторан, занимающий 6-й этаж бизнес-центра Olympic Plaza. Панорама: 300° вид на исторический центр Петербурга. Работает с 2009 года. Рейтинг 5,0, 2 606 отзывов. «Хорошее место 2026». Телефон: +7 (812) 991-10-90.",
        "list": [
          "Адрес: ул. Марата 5, Olympic Plaza, 6 этаж",
          "Открыт с 2009 года",
          "Рейтинг 5,0, 2 606 отзывов",
          "Бизнес-ланч от 590 ₽, средний чек ≈1 300 ₽"
        ]
      },
      {
        "heading": "Часто задаваемые вопросы",
        "body": "Вопрос: нужен ли пропуск в бизнес-центр? Ответ: нет, ресторан открыт для всех, вход через ресепшн Olympic Plaza. Вопрос: есть ли парковка? Ответ: да, внутренняя парковка комплекса. Вопрос: принимают ли карты? Ответ: да, все карты. Вопрос: как забронировать? Ответ: +7 (812) 991-10-90 или <a href='/' class='underline text-accent'>онлайн на сайте</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  }
];
